var SocketEvent;
(function (SocketEvent) {
    SocketEvent["AUDIO_DATA"] = "audio_data";
    SocketEvent["ERROR"] = "error";
    SocketEvent["RATE_LIMIT_REACHED"] = "rate_limit_breached";
    SocketEvent["SOCKET_ERROR"] = "connect_error";
})(SocketEvent || (SocketEvent = {}));
var SocketEmitEvent;
(function (SocketEmitEvent) {
    SocketEmitEvent["AUDIO_BY_MESSAGE_ID"] = "audioByMessageId";
    SocketEmitEvent["PREVIEW_VOICE"] = "previewVoice";
})(SocketEmitEvent || (SocketEmitEvent = {}));
export { SocketEmitEvent, SocketEvent };
